import { Box } from '@mui/material';

import { TAGBrand } from '@/types';
import { getBrandThemeColor } from '@/utils/brandThemeUtils';

import { wrapper, colorBlock } from './TAGDivider.styles';

const TAGDivider = () => {
	const brands = [TAGBrand.AspenDental, TAGBrand.ClearChoice, TAGBrand.Chapter, TAGBrand.WellNow, TAGBrand.Lovet];

	const getBrandColor = (brand: TAGBrand): string => {
		const themeColor = getBrandThemeColor(brand, 'palette.backgrounds.teamTagBrandColor');
		if (typeof themeColor === 'string') return themeColor;

		// Fallback to hardcoded values if needed
		switch (brand) {
			case TAGBrand.AspenDental:
				return '#2288C9';
			case TAGBrand.ClearChoice:
				return '#F99D25';
			case TAGBrand.Chapter:
				return '#CE0059';
			case TAGBrand.WellNow:
				return '#EB161E';
			case TAGBrand.Lovet:
				return '#39863C';
			default:
				return 'neutrals.transparent';
		}
	};

	return (
		<Box sx={wrapper} data-test-id="section_tagdivider">
			{brands.map((brand) => (
				<Box key={brand} sx={colorBlock(getBrandColor(brand))} />
			))}
		</Box>
	);
};

export default TAGDivider;
